const toDateString = (v) => v.date_delivered.toLocaleDateString('en-GB');
const numDisplay = (v, sign = "") => (n) => `${sign}${n[v].toLocaleString()}`;
// const parse
export const columns = [
    {
        key: 'date_received',
        title: 'Date received',
        value: (v) => v.date_received,
        renderValue: toDateString,
        sortable: true,
    },
    {
        key: 'date_delivered',
        title: 'Date delivered',
        value: (v) => v.date_delivered,
        renderValue: toDateString,
        sortable: true,
    },
    {
        key: 'title',
        title: 'Title',
        value: (v) => v.title,
        sortable: true,
    },
    {
        key: 'character_count',
        title: 'Character count',
        value: (v) => v.character_count,
        sortable: true,
        renderValue: numDisplay("character_count"),
    },
    {
        key: 'usd',
        title: 'USD',
        value: (v) => v.usd,
        sortable: true,
        renderValue: numDisplay("usd", "$"),
    },
    {
        key: 'nis',
        title: 'NIS',
        value: (v) => v.nis,
        sortable: true,
        renderValue: numDisplay("nis", "₪"),
    },
    {
        key: 'euro',
        title: 'Euro',
        value: (v) => v.euro,
        sortable: true,
        renderValue: numDisplay("euro", "€"),
    },
];
